import styled from '@emotion/styled';
import { colors } from 'ui_system/compass/utils/theme';

interface RadioBrandColorProps {
  brandColor?: string;
}

export const RadioButton = styled.input<RadioBrandColorProps>`
  appearance: none;
  margin-right: 10px;
  width: 24px;
  height: 24px;
  background-color: ${colors.background.light};
  border: 1px solid ${colors.borderAction};
  border-radius: 50%;
  &:checked {
    background: ${(props) => props.brandColor || colors.primary};
    border: 1px solid ${(props) => props.brandColor || colors.primary};
    fill: white;
  }
  &:checked + svg {
    opacity: 1;
    width: 10px;
    fill: white;
  }
  &:focus {
    border: 1px solid ${(props) => props.brandColor || colors.borderFocus};
  }
`;

export const RadioRowWrapper = styled.div`
  margin: 16px 10px 0px 10px;
`;

export const RadioText = styled.label`
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
  align-items: center;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  svg {
    opacity: 0;
    width: 10px;
    position: relative;
    right: 27px;
    pointer-events: none;
  }
`;

export const ErrorText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: red;
  margin-top: 5px;
`;

export const RadioLabelText = styled.div`
  width: 85%;
`;
